export default "__VITE_ASSET__BlTH2hQL__"